module.exports = __webpack_public_path__ + "images/ffea35301612738fc7c6fec063b0d620-bg.jpg";